import { ChamferFeatureDefinitionModel } from '../../../feature/definition/chamfer/ChamferFeatureDefinition';
import { ChamferFeaturePrototype } from '../../../feature/prototype/chamfer/ChamferFeaturePrototype';
import { ChamferPreviewObject } from '../chamfer/ChamferPreviewObject';
import { ChamferResultObject } from '../chamfer/ChamferResultObject';
import { FeatureMeshObjectFactory, type FeatureMeshObjectBuildInput } from './FeatureMeshObjectFactory';

/**
 * 倒角特征 mesh 对象工厂。
 */
export class ChamferMeshObjectFactory extends FeatureMeshObjectFactory {
    /**
     * @inheritdoc
     */
    public create(input: FeatureMeshObjectBuildInput) {
        if (input.isPreview) {
            if (
                input.context?.prototype instanceof ChamferFeaturePrototype
                && input.context.draftDefinition instanceof ChamferFeatureDefinitionModel
            ) {
                return new ChamferPreviewObject({
                    prototype: input.context.prototype,
                    draftDefinition: input.context.draftDefinition,
                    meshData: input.meshData,
                    geometry: input.geometry,
                    material: input.material,
                });
            }
            return null;
        }

        if (input.context?.prototype instanceof ChamferFeaturePrototype) {
            return new ChamferResultObject({
                prototype: input.context.prototype,
                meshData: input.meshData,
                geometry: input.geometry,
                material: input.material,
            });
        }

        return null;
    }
}
